var pad = Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

var unmaskPhone = String.prototype.unmaskPhone = function() {
  var phone = String(this)
  return phone.replace(/\D+/g, "")
}

//  const estimatePaymentSchedule = function(checkout, plan) {
//   let dayMillis = 24*60*60*1000 //1 day in milliseconds

//   let firstMonday = new Date()
//   firstMonday.setDate(checkout.getDate() + (1 + 7 - checkout.getDay()) % 7)

//   let payments = []
//   if(plan == 'checkout') { // approx 24 hours after checkout
//     let invoice = checkout
//     invoice.setTime(invoice.getTime() + (1*dayMillis));
//     payments = [invoice]
//   } else if (plan == 'plan30') { // Weekly on Monday
//     let secondMonday = new Date()
//     secondMonday.setTime(firstMonday.getTime() + (7*dayMillis))
//     let thirdMonday = new Date()
//     thirdMonday.setTime(firstMonday.getTime() + (14*dayMillis))
//     let fourthMonday = new Date()
//     fourthMonday.setTime(firstMonday.getTime() + (21*dayMillis))
//     payments = [firstMonday, secondMonday, thirdMonday, fourthMonday]
//   } else if (plan == 'plan60') { //Biweekly on Monday
//     let secondMonday = new Date()
//     secondMonday.setTime(firstMonday.getTime() + (14*dayMillis))
//     let thirdMonday = new Date()
//     thirdMonday.setTime(firstMonday.getTime() + (28*dayMillis))
//     let fourthMonday = new Date()
//     fourthMonday.setTime(firstMonday.getTime() + (42*dayMillis))
//     payments = [firstMonday, secondMonday, thirdMonday, fourthMonday]
//   }

// //   console.log('payment schedule is:',payments)
  
//   //Get ISO string version
//   let payments_iso = []
//   payments.forEach((item) => {
//     payments_iso.push(item.toISOString().substr(0, 10))
//   })

// //   console.log('payment schedule string is:', payments_iso)

//   return {payments: payments, payments_iso: payments_iso}
// }

const estimatePaymentSchedule = function(checkout, plan) {
    let dayMillis = 24*60*60*1000 //1 day in milliseconds
  
    let firstFriday = new Date()
    firstFriday.setDate(checkout.getDate() + (5 + 7 - checkout.getDay()) % 7)
  
    let payments = []
    if(plan == 'checkout') { // approx 24 hours after checkout
      let invoice = checkout
      invoice.setTime(invoice.getTime() + (1*dayMillis));
      payments = [invoice]
    } else if (plan == 'plan30') { // Weekly on Friday
      let secondFriday = new Date()
      secondFriday.setTime(firstFriday.getTime() + (7*dayMillis))
      let thirdFriday = new Date()
      thirdFriday.setTime(firstFriday.getTime() + (14*dayMillis))
      let fourthFriday = new Date()
      fourthFriday.setTime(firstFriday.getTime() + (21*dayMillis))
      payments = [firstFriday, secondFriday, thirdFriday, fourthFriday]
    } else if (plan == 'plan60') { //Biweekly on Friday
      let secondFriday = new Date()
      secondFriday.setTime(firstFriday.getTime() + (14*dayMillis))
      let thirdFriday = new Date()
      thirdFriday.setTime(firstFriday.getTime() + (28*dayMillis))
      let fourthFriday = new Date()
      fourthFriday.setTime(firstFriday.getTime() + (42*dayMillis))
      payments = [firstFriday, secondFriday, thirdFriday, fourthFriday]
    }
  
  //   console.log('payment schedule is:',payments)
    
    //Get ISO string version
    let payments_iso = []
    let tzOffset = ((new Date()).getTimezoneOffset()) * 60000; //offset in milliseconds
    // console.log('tzOffset:', tzOffset)
    payments.forEach((item) => {
        let offsetDate = new Date(item.getTime() - tzOffset)
        payments_iso.push(offsetDate.toISOString().substr(0, 10))
    })
  
  //   console.log('payment schedule string is:', payments_iso)
  
    return {payments: payments, payments_iso: payments_iso}
  }

const toISOString = function (time) {
    let tzOffset = ((new Date()).getTimezoneOffset()) * 60000; //offset in milliseconds
    let offsetDate = new Date(time.getTime() - tzOffset)
    return offsetDate.toISOString().substr(0, 10)
}

const themes = [
    {   //Theme 0
        primary:            '#6622c1', // purple
        primary_light:      '#7a44c2',
        primary_lighter:    '#956ccc',
        primary_dark:       '#520ab1',
        primary_darker:     '#41078f',
  
        secondary:          '#e71660', // pink
        secondary_light:    '#e7437d',
        secondary_lighter:  '#eb729d',
        secondary_dark:     '#e1004f',
        secondary_darker:   '#b80041',
  
        tertiary:           '#1f6ebc', // blue
        tertiary_light:     '#407Fbc',
        tertiary_lighter:   '#6899c7',
        tertiary_dark:      '#095aaa',
        tertiary_darker:    '#064889',
  
        quaternary:         '#ffea18', // yellow
        quaternary_light:   '#ffef4a',
        quaternary_lighter: '#fff37c',
        quaternary_dark:    '#ffe800',
        quaternary_darker:  '#d2bf00',
    },
    {   //Theme 1
        primary:            '#1157d8', // blue
        primary_light:      '#2c6bdd',
        primary_lighter:    '#4e83e3',
        primary_dark:       '#0943ad',
        primary_darker:     '#083587',
  
        secondary:          '#3c15db', // indigo
        secondary_light:    '#5432E0',
        secondary_lighter:  '#6f53e5',
        secondary_dark:     '#2c0bb3',
        secondary_darker:   '#230a8c',
  
        tertiary:           '#00D3BD', // teal
        tertiary_light:     '#19d9c5',
        tertiary_lighter:   '#3ddfce',
        tertiary_dark:      '#00a291',
        tertiary_darker:    '#007e70',
  
        quaternary:         '#ffa500', // orange
        quaternary_light:   '#ffb01d',
        quaternary_lighter: '#ffbe46',
        quaternary_dark:    '#ffa500',
        quaternary_darker:  '#ca8300',
    },
    {   //Theme 2 Wyndham Base Color
        primary:            '#405D65', // oceanic
        primary_light:      '#56727a',
        primary_lighter:    '#778e94',
        primary_dark:       '#2d454c',
        primary_darker:     '#1c363d',
  
        secondary:          '#4b7858', // green
        secondary_light:    '#659172',
        secondary_lighter:  '#8cb097',
        secondary_dark:     '#355a40',
        secondary_darker:   '#20492c',
  
        tertiary:           '#4a516e', // purple
        tertiary_light:     '#626985',
        tertiary_lighter:   '#858aa2',
        tertiary_dark:      '#353b53',
        tertiary_darker:    '#222843',
  
        quaternary:         '#a28465', // tan
        quaternary_light:   '#c4a789',
        quaternary_lighter: '#eed6bd',
        quaternary_dark:    '#7a6147',
        quaternary_darker:  '#62472b',
    },
]

export {
  pad,
  unmaskPhone,
  themes,
  estimatePaymentSchedule,
  toISOString,
}